export enum MimeType {
    XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    JPG = 'image/jpeg',
    JPEG = 'image/jpeg',
    PNG = 'image/png',
    MP4 = 'video/mp4',
    PDF = 'application/pdf',
    DOC = 'application/msword',
    TXT = 'text/plain',
    XLS = 'application/vnd.ms-excel',
    DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    XML = 'text/xml',
}
